export default __webpack_public_path__ + "4e9f343b5bc206bd01c82c60095f0e2c.svg";